"use client";

import styles from './index.module.scss';
import { packageTypeOptions } from '../data';

export default function PackagePreference({data, onChange}) {
    return (
        <div className={styles.container}>
            <h2>Choose Your Package</h2>
            <p className={styles.description}>Select the service model that works best for your business</p>

            <div className={styles.packageOptions}>
                {packageTypeOptions.map((option) => (
                    <div
                        key={option.value}
                        className={`${styles.packageCard} ${data.packageType === option.value ? styles.selected : ''}`}
                        onClick={() => onChange('packageType', option.value)}
                    >
                        <input
                            type="radio"
                            name="packageType"
                            value={option.value}
                            checked={data.packageType === option.value}
                            onChange={() => onChange('packageType', option.value)}
                        />
                        <div className={styles.packageContent}>
                            <div className={styles.packageHeader}>
                                <span className={styles.packageIcon}>{option.icon}</span>
                                <span className={styles.packageTitle}>{option.label}</span>
                            </div>
                            <p className={styles.packageDescription}>{option.description}</p>
                        </div>
                    </div>
                ))}
            </div>

            <div className={styles.summary}>
                <h3>Your Request Summary</h3>
                <div className={styles.summaryGrid}>
                    {data.name && (
                        <div className={styles.summaryItem}>
                            <span className={styles.summaryLabel}>Name:</span>
                            <span className={styles.summaryValue}>{data.name}</span>
                        </div>
                    )}
                    {data.email && (
                        <div className={styles.summaryItem}>
                            <span className={styles.summaryLabel}>Email:</span>
                            <span className={styles.summaryValue}>{data.email}</span>
                        </div>
                    )}
                    {data.phone && (
                        <div className={styles.summaryItem}>
                            <span className={styles.summaryLabel}>Phone:</span>
                            <span className={styles.summaryValue}>{data.phone}</span>
                        </div>
                    )}
                    {data.companyName && (
                        <div className={styles.summaryItem}>
                            <span className={styles.summaryLabel}>Company:</span>
                            <span className={styles.summaryValue}>{data.companyName}</span>
                        </div>
                    )}
                    {data.emirate && (
                        <div className={styles.summaryItem}>
                            <span className={styles.summaryLabel}>Location:</span>
                            <span className={styles.summaryValue}>{data.emirate}</span>
                        </div>
                    )}
                    {data.proStaffing && (
                        <div className={styles.summaryItem}>
                            <span className={styles.summaryLabel}>Has PRO Provider:</span>
                            <span className={styles.summaryValue}>
                                {data.proStaffing === 'yes-inhouse'
                                    ? 'Yes, In-house'
                                    : data.proStaffing === 'yes-outsourced'
                                    ? 'Yes, Outsourced'
                                    : 'No, I need help'}
                            </span>
                        </div>
                    )}
                    {data.requestVolume && (
                        <div className={styles.summaryItem}>
                            <span className={styles.summaryLabel}>Monthly Requests:</span>
                            <span className={styles.summaryValue}>{data.requestVolume}</span>
                        </div>
                    )}
                    {data.services && data.services.length > 0 && (
                        <div className={styles.summaryItem}>
                            <span className={styles.summaryLabel}>Services:</span>
                            <span className={styles.summaryValue}>{data.services.length} selected</span>
                        </div>
                    )}
                </div>
            </div>

            <div className={styles.note}>
                By submitting this request, you agree to be contacted by our PRO services team.
            </div>
        </div>
    )
}
